import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';

/**
 * Forces a single full page reload when entering a route via client-side navigation.
 * Works around a bug on /manage-sub-company that requires a fresh page load.
 */
@Injectable()
export class ReloadOnEnterGuard implements CanActivate {

    private static readonly STORAGE_KEY = 'reloadOnEnter';

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (sessionStorage.getItem(ReloadOnEnterGuard.STORAGE_KEY) === state.url) {
            sessionStorage.removeItem(ReloadOnEnterGuard.STORAGE_KEY);
            return true;
        }
        sessionStorage.setItem(ReloadOnEnterGuard.STORAGE_KEY, state.url);
        window.location.href = state.url;
        return false;
    }
}
